module.exports = __webpack_public_path__ + "static/media/male06.4654d4c3.jpg";